/**
 * Loops the newIndex value to either the length or 0
 * @param {number} newIndex
 * @param {number} length
 * @returns {number}
 */
export const loopIndex = (newIndex, length) => {
	if (newIndex >= length) {
		return 0;
	}
	else if (newIndex < 0) {
		return length - 1;
	}

	return newIndex;
};
